import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import Table from "../../../../../common/components/table";
import PageLoader from "../../../../../components/PageLoader";
import { selectScheduledTasksListItems } from "../../../../../redux/scheduled-tasks/selector";
import { scheduledTasks } from "../../../../../redux/scheduled-tasks/action";

const ManagementScheduledTasks = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const navigate = useNavigate()
    const itemsData = useSelector(selectScheduledTasksListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name' },
      { field: 'LastStartUtc', headerName: 'Last Start Date' , isDateValueFormat: true},
      { field: 'LastEndUtc', headerName: 'Last End Date' , isDateValueFormat: true},
      { field: 'LastSuccessUtc', headerName: 'Last Success Date' , isDateValueFormat: true },
      { headerName: 'Execute', isExecute: true },
        ]);
      }
      const handleAdd=()=>{
        navigate(`${0}`)
      }
     
      const handleEdit=(data: any)=>{
        
        navigate(`${data?.Id}`)
      }
      
      const additionButtons: any = [
        {
          name: 'Add Scheduled Task',
          callback: () => handleAdd(),
        }
      ];
      const fetchScheduledTask=()=>{
        dispatch(scheduledTasks.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks/list`,
            entity: 'scheduledTasks',jsonData:{
      
        "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        
    
        }}))
      }
      const handleDelete=(data: any)=>{
        dispatch(scheduledTasks.delete({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks/delete`,
          entity: 'scheduledTasks',
          jsonData: {
              Records: [
                  {
                      Id: data?.Id
                  }
              ]
          }
      })).then(() => {
          dispatch(scheduledTasks.list({
              url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks/list`,
              entity: 'scheduledTasks',
              jsonData: { "PageNumber": pageData,
              "PageSize": 10,
              "SortField": "Id",
              "SortOrder": "desc",}
          }));
      });
      }
      const handleRunScheduledTask = async (data: any) => {
       
        dispatch(scheduledTasks.create({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks/execute`,
          entity: 'scheduledTasks',
          jsonData: {
            Records: [
              {
                Id: data?.Id
              }
            ]
       
      }})).then(()=>{
        dispatch(scheduledTasks.list({
          url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/system/scheduled-tasks/list`,
          entity: 'scheduledTasks',jsonData:{
    
      "PageNumber": pageData,
      "PageSize": 10,
      "SortField": "Id",
      "SortOrder": "desc",
      
  
      }}))
      });
      }
	useEffect(() => {
        createColumnDefs()
        fetchScheduledTask()
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
		<Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} onDelete={handleDelete}
    paginationData={itemsData?.result?.pagination}     handleRunScheduledTask={handleRunScheduledTask} onEdit={handleEdit} additionButtons={additionButtons} headingName="Scheduled Tasks"/>

  }
  </>
	);
};

export default ManagementScheduledTasks;


